import React, { useState } from 'react';
import { Fab } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ShareIcon from '@mui/icons-material/Share';
import { styled } from '@mui/system';

function Design() {
  const [showButtons, setShowButtons] = useState(false);

  const handleClick = () => {
    setShowButtons(!showButtons);
  };

  return (
    <div style={{ position: 'relative', height: '100vh' }}>
      {/* Main FAB */}
      <Fab
        color="primary"
        aria-label="add"
        onClick={handleClick}
        style={{
          position: 'absolute',
          bottom: '20px',
          right: '20px',
          zIndex: 10,
        }}
      >
        <AddIcon />
      </Fab>

      {/* Additional FAB buttons */}
      {showButtons && (
        <>
          <AnimatedButton
            style={{
              position: 'absolute',
              bottom: '80px',
              right: '20px',
              animation: 'slideIn 0.3s ease-out',
            }}
          >
            <EditIcon />
          </AnimatedButton>
          <AnimatedButton
            style={{
              position: 'absolute',
              bottom: '140px',
              right: '20px',
              animation: 'slideIn 0.3s ease-out 0.1s',
            }}
          >
            <DeleteIcon />
          </AnimatedButton>
          <AnimatedButton
            style={{
              position: 'absolute',
              bottom: '200px',
              right: '20px',
              animation: 'slideIn 0.3s ease-out 0.2s',
            }}
          >
            <ShareIcon />
          </AnimatedButton>
        </>
      )}

      {/* Animations using CSS */}
      <style>
        {`
          @keyframes slideIn {
            from {
              opacity: 0;
              transform: translateY(20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
      </style>
    </div>
  );
}

// Styled component for the additional buttons
const AnimatedButton = styled(Fab)({
  transition: 'all 0.3s ease',
});

export default Design;
